/**
 * ChangelogCleanupButton - Przycisk do czyszczenia starych wpisów changelog
 * Tylko dla administratorów
 */
import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  TextField,
  CircularProgress,
  Alert,
  Box
} from '@mui/material';
import {
  Delete as DeleteIcon
} from '@mui/icons-material';
import { changelogAPI } from '../services/apiWithAuth';

const ChangelogCleanupButton = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [daysToKeep, setDaysToKeep] = useState(30);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleOpen = () => {
    setOpen(true);
    setResult(null);
    setError(null);
  };

  const handleClose = () => {
    if (!loading) {
      setOpen(false);
    }
  };

  const handleCleanup = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await changelogAPI.cleanup(daysToKeep);
      setResult(response.message);
    } catch (err) {
      console.error('Cleanup error:', err);
      setError(err.response?.data?.detail || 'Błąd podczas czyszczenia changelog');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        color="warning"
        startIcon={<DeleteIcon />}
        onClick={handleOpen}
        size="small"
      >
        Wyczyść changelog
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Czyszczenie historii zmian</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Usuń stare wpisy changelog, aby zoptymalizować bazę danych.
            Domyślnie zachowywane są wpisy z ostatnich 30 dni.
          </DialogContentText>

          <TextField
            fullWidth
            type="number"
            label="Liczba dni do zachowania"
            value={daysToKeep}
            onChange={(e) => setDaysToKeep(parseInt(e.target.value) || 30)}
            inputProps={{ min: 1, max: 365 }}
            helperText="Wpisy starsze niż ta liczba dni zostaną usunięte"
            disabled={loading}
            sx={{ mb: 2 }}
          />

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {result && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {result}
            </Alert>
          )}

          <Alert severity="warning">
            <strong>Uwaga:</strong> Tej operacji nie można cofnąć. 
            Upewnij się, że zachowujesz właściwą ilość dni historii.
          </Alert>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            {result ? 'Zamknij' : 'Anuluj'}
          </Button>
          {!result && (
            <Button
              onClick={handleCleanup}
              color="warning"
              variant="contained"
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : <DeleteIcon />}
            >
              {loading ? 'Czyszczenie...' : 'Wyczyść'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ChangelogCleanupButton;
